import { FLEXIBLE_COMPONENTS } from '@/constants';
const { ARTICLE_CARDS, PARTNER_PODIUM, SUMMARY } = FLEXIBLE_COMPONENTS;

export const CategoryPageProps = {
    maxWidth: {
        type: String,
        default: '1200px',
    },
    showOurSitesText: {
        type: Boolean,
        default: true,
    },
    showSidebar: {
        type: Boolean,
        default: true,
    },
    showSummarySidebar: {
        type: Boolean,
        default: false,
    },
    sidebarPosition: {
        type: String,
        default: 'right',
    },
    isSidebarSticky: {
        type: Boolean,
        default: false,
    },
    partnerRowType: {
        type: String,
        default: 'PartnerRowAlpha',
    },
    showRankingBackgroundImage: {
        type: Boolean,
        default: false,
    },
};

export const FlexibleSpaceDefaults = {
    spaceAMobile: [],
    spaceADesktop: [PARTNER_PODIUM],
    spaceBMobile: [PARTNER_PODIUM, ARTICLE_CARDS],
    spaceBDesktop: [ARTICLE_CARDS],
    spaceCMobile: [SUMMARY],
    spaceCDesktop: [SUMMARY],
};
